// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"ResultDeal_iconSync__2YEqf","fa-spin":"ResultDeal_fa-spin__1SN4n","iconInfo":"ResultDeal_iconInfo__YkKI2"};